import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "src/providers";
import { ROUTES } from "../constants";
import AppLayout from "./Layout";
import Dashboard from "./Dashboard";
import AllReportsAndAnalysis from "./AllReportsAndAnalysis";
import AllActivities from "./AllActivities";
import { MFRCreatePage } from "./MFR";
import { ReportViewWrapper } from "./ReportView";
import { WorkflowsPage } from "./Workflow";
import { CapabilitiesListPage, CapabilityEditPage } from "./Capability";
import "../index.scss";

const App: React.FC = () => {
  return (
    <BrowserRouter>
      <ThemeProvider>
            <AppLayout>
            <Routes>
              {/* Redirect root path to dashboard */}
              <Route
                path="/"
                element={<Navigate to={ROUTES.DASHBOARD} replace />}
              />

              {/* Dashboard route with layout */}
              <Route path={ROUTES.DASHBOARD} element={<Dashboard />} />

              {/*/!* All Reports and Analysis route *!/*/}
              {/*<Route*/}
              {/*  path={ROUTES.REPORTS_ALL}*/}
              {/*  element={<AllReportsAndAnalysis />}*/}
              {/*/>*/}

              {/* All Activities route */}
              <Route
                path={ROUTES.ACTIVITIES_ALL}
                element={<AllActivities />}
              />

              {/* Workflows route */}
              <Route path={ROUTES.WORKFLOWS} element={<WorkflowsPage />} />

              {/* Capabilities routes */}
              <Route path={ROUTES.CAPABILITIES} element={<CapabilitiesListPage />} />
              <Route path={`${ROUTES.CAPABILITIES_EDIT}/:id`} element={<CapabilityEditPage />} />

              {/* MFR routes */}
              <Route path={ROUTES.MFR_CREATE} element={<MFRCreatePage />} />
              <Route path={ROUTES.MFR_VIEW} element={<WorkflowsPage tag="MFR" />} />
              <Route path={ROUTES.MFR_EDIT} element={<MFRCreatePage />} />

              {/* Net PPM routes */}
              <Route path={ROUTES.NETPPM_VIEW} element={<WorkflowsPage tag="PPM" />} />

              {/* RVM routes */}
              <Route path={ROUTES.RVM_VIEW} element={<WorkflowsPage tag="RVM" />} />

              {/* Report view route */}
              <Route path="/report/view" element={<ReportViewWrapper />} />

              <Route path="*" element={<Navigate to={ROUTES.DASHBOARD} />} />
            </Routes>
          </AppLayout>
      </ThemeProvider>
    </BrowserRouter>
  );
};

export default App;
